/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingRegionResponse {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingRegionResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingRegionResponse>): AwsSecurityHubFindingRegionResponse {
        let obj = Object.assign(new AwsSecurityHubFindingRegionResponse(), model);
        AwsSecurityHubFindingRegionResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingRegionResponse>): AwsSecurityHubFindingRegionResponse {
        if (!model) return null;
        return AwsSecurityHubFindingRegionResponse.newInstance(<AwsSecurityHubFindingRegionResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingRegionResponse) {
        if (!obj) return;

        models.AwsSecurityHubFindingRegionResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingRegionResponse): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingRegionResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of Regions
     */
    regions: Array<string>;

}
